import React from 'react';
import PageAuthorize from '../../../../security/PageAuthorize';
import ListContainer from '../../../../presentation/ListContainer';
import fleet from './fleet.layout.json';
import wholesale from './wholesale.layout.json';
import entity from './entity.layout.json';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';

class UsersList extends React.Component {

  constructor( props ) {
    super( props );
    this.state = {
      ready: false,
      layout: {}
    };
  }

  getProfile() {
    const user = this.props.user;
    let profile = {
      company_type_id: 9999
    };

    if( user !== undefined ) {
      if( user.profile !== undefined && user.profile !== '' ) {
        return user.profile;
      } else {
        return profile;
      }
    }
    return profile;
  }

  componentWillMount(){
    const profile = this.getProfile();
    const company_type_id = profile.company_type_id;

    // FLEET = 1
    // WHOLESALE = 2
    // ENTITY = 3
    if ( company_type_id === 1 ) {
      // Fleet User
      this.setState( {
        ready: true,
        layout: fleet
      } );

    } else if ( company_type_id === 2 ) {

      // Wholesale User
      this.setState( {
        ready: true,
        layout: wholesale
      } );

    } else if ( company_type_id === 3 ) {

      // Entity User
      this.setState( {
        ready: true,
        layout: entity
      } );

    } else {

      const history = this.props.history;
      history.push( '/' );
    }
  }

  render(){
    if( this.state.ready === true ){
      return (
        <PageAuthorize groups={['Administrators','Operations','Wholesale Team Admin','Entity Team Admin']}>
          <ListContainer
            id="UsersList"
            layout={this.state.layout}
            selectedtab={1}
          />
        </PageAuthorize>
      );
    } else {
      return (
        <span></span>
      );
    }
  }
}

export default withRouter(
  connect (
    ( store ) => {
      return {
        auth: store.auth.auth,
        bugsnag: store.bugsnag.Bugsnag,
        user: store.user.user
      };
    }
  )( UsersList ) );



// WEBPACK FOOTER //
// ./src/content/admin/users/components/UsersList.js